// extracted by mini-css-extract-plugin
module.exports = {"render":"styles_render__3Xocn","wallpaper":"styles_wallpaper__266bS","content":"styles_content__1ULFu","link":"styles_link__1EWYI"};